import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';

import { SmartRecruitersHealthCheckBanner_SmartRecruitersFragment } from 'src/generated/mloop-graphql';

import AppWideBanner, { AppWideBannerAction } from '../AppWideBanner';

interface Fragments {
  smartRecruiters: SmartRecruitersHealthCheckBanner_SmartRecruitersFragment;
}

interface Props {
  retry: AppWideBannerAction;
}

const SmartRecruitersHealthCheckBanner: FCWithFragments<Fragments, Props> = ({ smartRecruiters, retry }) => {
  const { t } = useTranslation();
  // hide if its not installed or is healthy
  if (!smartRecruiters || !smartRecruiters?.isInstalled || smartRecruiters?.isHealthy) {
    return null;
  }

  return (
    <AppWideBanner
      color="foreground"
      backgroundColor="error"
      text={t('hiring-dashboard-nav:nav.banner.integrationUnhealthy', { integrationName: 'SmartRecruiters' })}
      action={retry}
    />
  );
};

SmartRecruitersHealthCheckBanner.fragments = {
  smartRecruiters: gql`
    fragment SmartRecruitersHealthCheckBanner_smartRecruiters on SmartRecruitersIntegrationHealth {
      isInstalled
      isHealthy
    }
  `,
};

export default SmartRecruitersHealthCheckBanner;
